import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import styles from "./paymentlist.module.css";
import detailsStyles from "../incomeGridDetails.module.css";
import { ArrowLeft, Check, CreditCard, FileMinus, X } from "react-feather";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { TableLoader } from "../../../../../../../components/LoaderC";
import PaymentCard from "./PaymentCard";
import InfiniteScroll from "react-infinite-scroller";
import { RefundContext } from "./RefundParts";
import RecordRefund from "../paymentcomps/RecordRefund";

const PaymentList = ({ contentLoading, data, setPage, page, hasMore, setLoading, setSnackbarOpen, setSnackbarMsg, setAddBillModalShow, setAddCreditModalShow, setAddPaymentModalShow, setIsUpdate, setEditId, setDeleteModalShow, setDeleteId, setDeleteType, rentRollData, onRefundSaved }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [taskExpanded, setTaskExpanded] = useState("");
    // { item, refund } while the Record Refund window is open (refund set when editing)
    const [refundTarget, setRefundTarget] = useState(null);
    const [refundToDelete, setRefundToDelete] = useState(null);

    const refundSaved = () => {
        onRefundSaved && onRefundSaved();
    }

    const refundActions = {
        openRefund: (item, refund) => setRefundTarget({ item, refund }),
        deleteRefund: (item, refund) => setRefundToDelete({ item, refund }),
    };

    const confirmDeleteRefund = async () => {
        const { item, refund } = refundToDelete;
        setRefundToDelete(null);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.delete(process.env.REACT_APP_PAYMENT_API_URL + "v1/rent-rolls/" + item?.rent_roll_id + "/list/" + item?.id + "/refunds/" + refund?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            refundSaved();
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const handleChange = (panel) => (event, isTaskExpanded) => {
        setTaskExpanded(isTaskExpanded ? panel : false);
    }

    return (<RefundContext.Provider value={refundActions}>
        {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
        </div>)}
        {!contentLoading && <div className={`${styles.RentRollListSec}`}>
            <div className="FormAccording RentRoll Theme">
                <div className={`${styles.RentRollListHeader}`}>
                    <div className={`${styles.HeaderUnder}`}>
                        <p className={`${styles.Text}`}>Date</p>
                        <p className={`${styles.Text}`}>Description</p>
                        <p className={`${styles.Text} ${styles.Bill}`}>Charged (Bill)</p>
                        <p className={`${styles.Text} ${styles.Payment}`}>Paid (Payment)</p>
                        <p className={`${styles.Text} ${styles.Balance}`}>Running Balance</p>
                    </div>
                </div>

                <InfiniteScroll
                    pageStart={0}
                    initialLoad={false}
                    loadMore={() => {
                        if (hasMore) {
                            setPage((prev) => prev + 1);
                        }
                    }}
                    hasMore={hasMore}
                    threshold={150}
                    loader={<div className={`${styles.CSSLoaderSec}`} key={0}>
                        <span className={`${styles.CSSCuatomLoader}`}></span>
                        <p>Loading...</p>
                    </div>}
                >
                    <div className={`${styles.RentRollMonthGroup}`}>
                        {data?.map((item, index) => {
                            return <PaymentCard key={index} item={item} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddBillModalShow={setAddBillModalShow.bind(this)} setAddCreditModalShow={setAddCreditModalShow.bind(this)} setAddPaymentModalShow={setAddPaymentModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} />
                        })}
                    </div>
                </InfiniteScroll>

                {/*<div className={`${styles.RentRollMonthGroup}`}>
                    

                    <div className={`${styles.MonthDivider}`}>
                        <span className={`${styles.MonthLabel}`}>April 2026</span>
                        <div className={`${styles.MonthLine}`}></div>
                        <span className={`${styles.MonthSum}`}>Billed $1,250 &nbsp;·&nbsp; Collected $1,250</span>
                    </div>
                    <Accordion expanded={taskExpanded === "panel1"} onChange={handleChange("panel1")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 11</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Remaining balance</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Payment sent</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentOk}`}>
                                        <div className={`${styles.Label}`}><Check /> Collected</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceZero}`}>
                                        <div className={`${styles.Label}`}>Cleared</div>
                                        <div className={`${styles.Amount}`}>$0.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Remaining balance</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$250.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Completed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>Cash App Pay</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel2"} onChange={handleChange("panel2")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Red}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 9</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Red}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Half — payment failed</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>ACH Transfer</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentFaild}`}>
                                        <div className={`${styles.Label}`}><X /> Failed</div>
                                        <div className={`${styles.Amount}`}>$1,050.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Half</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$1,050.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Failed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 9, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>ACH Transfer</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>—</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>—</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.BlueTwo}`}>Retry Payment</button>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel3"} onChange={handleChange("panel3")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 9</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Half</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Payment sent</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentOk}`}>
                                        <div className={`${styles.Label}`}><Check /> Collected</div>
                                        <div className={`${styles.Amount}`}>$1,000.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Half</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$1,000.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Completed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 8, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>Cash App Pay</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>Apr 8, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel4"} onChange={handleChange("panel4")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Yellow}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 4</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Yellow}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><FileMinus /></div>
                                        <div className={`${styles.Title}`}>Late Fee for April</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Bill issued</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.Label}`}>Charged</div>
                                    <div className={`${styles.Amount}`}>$50.00</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$1,250.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Invoice No.</div>
                                            <div className={`${styles.Text}`}>102117</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Issued On</div>
                                            <div className={`${styles.Text}`}>Apr 4, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Due Date</div>
                                            <div className={`${styles.Text}`}>Apr 4, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Notes</div>
                                            <div className={`${styles.Text}`}>Late fee applied for April rent</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Red}`}>Delete</button>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Bill</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={taskExpanded === "panel5"} onChange={handleChange("panel5")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Blue}`}>
                                    <div className={`${styles.RentRollDate}`}>Apr 1</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Blue}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><FileMinus /></div>
                                        <div className={`${styles.Title}`}>Monthly Rent for April</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Bill issued</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.Label}`}>Charged</div>
                                    <div className={`${styles.Amount}`}>$1,200.00</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceOwnd}`}>
                                        <div className={`${styles.Label}`}>Balance due</div>
                                        <div className={`${styles.Amount}`}>$1,200.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Invoice No.</div>
                                            <div className={`${styles.Text}`}>102108</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>Monthly</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Issued On</div>
                                            <div className={`${styles.Text}`}>Mar 27, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Due Date</div>
                                            <div className={`${styles.Text}`}>Apr 1, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Notes</div>
                                            <div className={`${styles.Text}`}>Monthly rent charge for April 2026</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Red}`}>Delete</button>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Bill</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
                {/*<div className={`${styles.RentRollMonthGroup}`}>
                    <div className={`${styles.MonthDivider}`}>
                        <span className={`${styles.MonthLabel}`}>March 2026</span>
                        <div className={`${styles.MonthLine}`}></div>
                        <span className={`${styles.MonthSum}`}>Billed $50 &nbsp;·&nbsp; Collected $1,250</span>
                    </div>
                    <Accordion expanded={taskExpanded === "panel6"} onChange={handleChange("panel6")}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                            <div className={`${styles.NotesCard}`}>
                                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                                    <div className={`${styles.RentRollDate}`}>Mar 10</div>
                                    <div className={`${styles.RentRollYear}`}>2026</div>
                                </div>
                                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                                    <div className={`${styles.Top}`}>
                                        <div className={`${styles.Badge}`}><CreditCard /></div>
                                        <div className={`${styles.Title}`}>Rest of rent</div>
                                    </div>
                                    <div className={`${styles.SubText}`}>Payment sent</div>
                                </div>
                                <div className={`${styles.RentRollDue}`}>
                                    <div className={`${styles.DueEmpty}`}>—</div>
                                </div>
                                <div className={`${styles.RentRollPayment}`}>
                                    <div className={`${styles.PaymentOk}`}>
                                        <div className={`${styles.Label}`}><Check /> Collected</div>
                                        <div className={`${styles.Amount}`}>$250.00</div>
                                    </div>
                                </div>
                                <div className={`${styles.RentRollBalance}`}>
                                    <div className={`${styles.BalanceZero}`}>
                                        <div className={`${styles.Label}`}>Cleared</div>
                                        <div className={`${styles.Amount}`}>$0.00</div>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={`${styles.CussAccoRow}`}>
                            <div className={`${styles.RentRollExpandSec}`}>
                                <div className={`${styles.DetailsSec}`}>
                                    <div className={`${styles.DetailsGrid}`}>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Payer</div>
                                            <div className={`${styles.Text}`}>Kimora Love</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Memo</div>
                                            <div className={`${styles.Text}`}>Remaining balance</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Amount</div>
                                            <div className={`${styles.Text}`}>$250.00</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Type</div>
                                            <div className={`${styles.Text}`}>One Time</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Status</div>
                                            <div className={`${styles.Text}`}>Completed</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Sent On</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Method</div>
                                            <div className={`${styles.Text}`}>Cash App Pay</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Deposit Date</div>
                                            <div className={`${styles.Text}`}>Apr 11, 2026</div>
                                        </div>
                                        <div className={`${styles.DetailsCell}`}>
                                            <div className={`${styles.Label}`}>Account</div>
                                            <div className={`${styles.Text}`}>ZuJiKOOPVA</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.ButtonSec}`}>
                                    <button className={`${styles.Button} ${styles.Blue}`}>Resend Receipt</button>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>*/}

            </div>
        </div>}

        <Dialog
            fullWidth
            maxWidth="xs"
            open={!!refundTarget}
            onClose={(e) => setRefundTarget(null)}
            aria-labelledby="record-refund-title"
            className="NewPopUp MobileForm"
        >
            <DialogTitle id="record-refund-title">
                <button className={`${detailsStyles.BackAddBU}`} onClick={(e) => setRefundTarget(null)}>
                    <ArrowLeft />
                </button>
                {refundTarget?.refund ? "Edit Refund" : "Record Refund"}
                <button onClick={(e) => setRefundTarget(null)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent className={`${detailsStyles.RequestBodyPop}`}>
                {refundTarget && <RecordRefund
                    rent_roll_id={refundTarget.item?.rent_roll_id}
                    item={refundTarget.item}
                    refund={refundTarget.refund}
                    rentRollData={rentRollData}
                    setModalShow={() => setRefundTarget(null)}
                    setLoading={setLoading}
                    setSnackbarMsg={setSnackbarMsg}
                    setSnackbarOpen={setSnackbarOpen}
                    onSaved={refundSaved}
                />}
            </DialogContent>
        </Dialog>

        <Dialog
            open={!!refundToDelete}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setRefundToDelete(null)}
            aria-labelledby="delete-refund-title"
            className="NewPopUp"
        >
            <DialogTitle id="delete-refund-title">
                Are you sure you want to delete the refund?
                <button onClick={(e) => setRefundToDelete(null)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The refund of {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(refundToDelete?.refund?.amount || 0)} will be removed and the payment applied again. You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="CancelPopupBU" onClick={(e) => confirmDeleteRefund()}>Delete</Button>
                <Button onClick={(e) => setRefundToDelete(null)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>
    </RefundContext.Provider>);
}

export default PaymentList;